import { ContactInfo } from './contactInfoDetection';

export function hasContactInfo(text: string): boolean {
  // Regex pour détecter emails
  const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
  
  // Regex pour détecter numéros de téléphone (formats variés)
  const phoneRegex = /(\+\d{1,3}[ -]?)?\(?\d{2,4}\)?[ -]?\d{2,4}[ -]?\d{2,4}[ -]?\d{2,4}/g;
  
  return emailRegex.test(text) || phoneRegex.test(text);
}

export function highlightContactInfo(text: string): string {
  if (!text) return '';
  
  // Regex pour détecter emails
  const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
  
  // Regex pour détecter numéros de téléphone (formats variés)
  const phoneRegex = /(\+\d{1,3}[ -]?)?\(?\d{2,4}\)?[ -]?\d{2,4}[ -]?\d{2,4}[ -]?\d{2,4}/g;
  
  // Remplace les emails par des versions surlignées
  let highlightedText = text.replace(emailRegex, match => {
    return `<span class="font-bold text-white bg-gradient-to-r from-blue-600/50 to-teal-500/50 py-0.5 px-1.5 rounded inline-block">${match}</span>`;
  });
  
  // Remplace les numéros de téléphone par des versions surlignées
  highlightedText = highlightedText.replace(phoneRegex, match => {
    return `<span class="font-bold text-white bg-gradient-to-r from-blue-600/50 to-teal-500/50 py-0.5 px-1.5 rounded inline-block">${match}</span>`;
  });
  
  return highlightedText;
}